export default "__VITE_ASSET__ab2397ff__"